import * as React from 'react';
import { Popper, Tooltip } from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/styles';
import { ICompanyData, useGetCompanyApi } from '../services/useLogDictionariesApi';
import { useTranslation } from "react-i18next";
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
	root: {
		cursor: 'default',
		whiteSpace: 'nowrap',
	},
}));

const HtmlTooltip = withStyles((theme) => ({
	tooltip: {
		backgroundColor: '#fff',
		color: '#333',
		width: 300,
		fontSize: '12px',
		border: 'none',
		boxShadow: '0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)',
		padding: '0px',
	},
}))(Tooltip);


const useTooltipStyles = makeStyles((theme) => ({
	header: {
		fontSize: '1.25rem',
		fontWeight: 500,
		padding: '14px',
	},
	content: {
		padding: '0px 14px 0px 14px',
	},
	contact: {
		padding: '14px',
		borderTop: '1px solid #ddd',
		marginTop: '7px',
		paddingTop: '7px',
	},
	name: {
		fontWeight: 800,
	}
}));

interface ITooltipContentProps {
	value: string,
	data: ICompanyData,
	onLoaded: (d: ICompanyData) => void,
}

function TooltipContent(props: ITooltipContentProps) {
	const classes = useTooltipStyles();
	const { t } = useTranslation();
	const [setName, data, isLoading, isError] = useGetCompanyApi();

	React.useEffect(() => {
		if (!props.data && !isLoading && !isError) {
			setName(props.value);
		}
	}, [props.value])

	React.useEffect(() => {
		if (!props.data) {
			props.onLoaded(data);
		}
		
	}, [data]);

	const companyData = props.data;
	return <div>
		<h1 className={classes.header}>{props.value}</h1>
		{isError && <>
			<p className="text-danger">Nieoczekiwany problem przy pobraniu firmy.</p>
		</>}
		{companyData?.status === 'NotFound' && <>
			<div>Nie znaleziono firmy w LOG.</div>
		</>}

		{companyData?.status === 'Success' && <>
			<div className={classes.content}>
				{companyData.email && <div><a href={"mailto:" + companyData.email}>{companyData.email}</a></div>}
				{companyData.phone && <div><a href={"tel:" + companyData.phone}>{companyData.phone}</a></div>}
				<div>{companyData.address}</div>
				<div>{companyData.zipCode} {companyData.city}</div>

				{companyData.nip && <div>{t("common.label.nip")}: {companyData.nip}</div>}
			
				{companyData.regon && <div>{t("common.label.regon")}: {companyData.regon}</div>}
			</div>

			{companyData.contacts && companyData.contacts.length > 0 && <div>
				{companyData.contacts.map(c => <div key={c.id} className={classes.contact}>
					<div className={classes.name}>{c.firstName} {c.surname}</div>
					<div>{c.position}</div>
					{c.email && <div><a href={"mailto:" + c.email}>{c.email}</a></div>}
					{c.phone && <div><a href={"tel:" + c.phone}>{c.phone}</a></div>}
					{c.communicator && <div>{c.communicator}</div>}
				</div>)}
			</div>}
			
		</>}
	</div>
}

interface IProps {
	value: string,
	className?: string,
}

export default function LogCompanyTooltip(props: React.PropsWithChildren<IProps>)
{
	const classes = useStyles();
	const [temp, setTemp] = React.useState<ICompanyData>(null);

	React.useEffect(() => {
		setTemp(null);
	}, [props.value]);

	if (!props.value) {
		return null;
	}

	return <HtmlTooltip
		PopperComponent={Popper}
		title={<TooltipContent value={props.value} onLoaded={setTemp} data={temp} />}
		interactive
		placement="bottom-start"
		enterDelay={1000}
		leaveDelay={200}
	>
		<span className={clsx(classes.root, props.className)} >
			{!props.children && <>{props.value}</>}
			{props.children && <>{props.children}</>}
		</span>
	</HtmlTooltip>
}

